import { createFileRoute, redirect } from '@tanstack/react-router'

import { readAdminSession } from '@/lib/auth/session-store'
import { AdminLoginPage } from '@/features/auth/AdminLoginPage'

export const Route = createFileRoute('/admin/login')({
  beforeLoad: () => {
    if (readAdminSession()) throw redirect({ to: '/admin/clubs' })
  },
  component: AdminLoginPage,
})
